<div class="footer-public" id="footer-area-publica">
  <div class="footer-container-content">
    <img src="../../../../assets/img/novo-logo-branco.png" alt="logo ecossistema">
    <p class="subtitle-logo">Um ecossistema de inovação é um ambiente onde estão presentes empresas,
      empreendedores e agentes que podem atuar de forma harmônica e colaborativa.</p>
  </div>
</div>